import {
    Box,
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import { useRef } from "react";
import { useTranslate } from "react-admin";
import ContentAdd from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export const SerialNumberField = ({ serialNumbers, setSerialNumbers, required, error }) => {
    const translate = useTranslate();
    const refInput = useRef();
    const addSerialNumber = (serialNumber) => {
        refInput.current.value = "";
        if (serialNumber && serialNumbers.includes(serialNumber)) {
            return;
        }
        setSerialNumbers([...serialNumbers, serialNumber ? serialNumber : "N/A"]);
    };

    const removeSerialNumber = (index) => {
        setSerialNumbers((prev) => prev.filter((_, i) => i !== index));
    };
    return (
        <Box sx={{ 
            width: "100%", 
            height: "100%", 
            display: "flex", 
            flexDirection: "column",
            border: error ? "2px solid #d32f2f" : "none",
            borderRadius: error ? 1 : 0,
            padding: error ? 1 : 0,
            backgroundColor: error ? "rgba(211, 47, 47, 0.04)" : "transparent"
        }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "baseline",
                    mb: 3,
                    width: "100%",
                    maxHeight: "60px",
                    flex: "0 0 auto",
                }}
            >
                <TextField
                    fullWidth
                    title={translate("equip.serialNumber")}
                    label={translate("equip.serialNumber")}
                    source="sku"
                    required={required && serialNumbers.length < 1}
                    inputRef={refInput}
                    type="tel"
                    error={error}
                    helperText={error ? translate("equip.serialNumberRequired") : undefined}
                />
                <Button
                    aria-label={translate("equip.add")}
                    sx={{
                        color: (theme) => theme.palette.getContrastText(theme.palette.primary.main),
                        backgroundColor: (theme) => theme.palette.primary.main,
                        borderRadius: "50%",
                        height: "48px",
                        minWidth: "48px",
                        padding: "0px!important",
                        marginLeft: 3,
                    }}
                    onClick={() => addSerialNumber(refInput.current.value)}
                >
                    <ContentAdd />
                </Button>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
                <SerialNumberTable
                    serialNumbers={serialNumbers}
                    removeSerialNumber={removeSerialNumber}
                />
            </Box>
        </Box>
    );
};

const SerialNumberTable = ({ serialNumbers, removeSerialNumber }) => {
    const translate = useTranslate();

    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell align="left">{translate("equip.serialNumber")}</TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {serialNumbers.map((serialNumber, index) => (
                        <TableRow
                            key={index}
                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {index + 1}
                            </TableCell>
                            <TableCell align="left">{serialNumber}</TableCell>
                            <TableCell align="right">
                                <Button
                                    aria-label={translate("ra.action.delete")}
                                    onClick={() => removeSerialNumber(index)}
                                >
                                    <DeleteIcon color="error" />
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
